module.exports = __webpack_public_path__ + "img/table-nodata.7bbe939f.png";